const BASE_FONTS = ['monospace', 'sans-serif', 'serif'] as const;

const TEST_FONTS = [
  'Arial', 'Verdana', 'Times New Roman', 'Courier New', 'Comic Sans MS',
  'Georgia', 'Impact', 'Trebuchet MS', 'Palatino', 'Tahoma', 'Helvetica',
  'Geneva', 'Menlo', 'Monaco', 'Didot', 'Gill Sans',
  'Segoe UI', 'Candara', 'Consolas', 'Franklin Gothic Medium', 'Book Antiqua',
  'Roboto', 'Open Sans', 'Lato', 'Oswald', 'Montserrat',
  'Futura', 'Garamond', 'Baskerville', 'Optima', 'Lucida Bright', 'Century Gothic',
  'Arial Unicode MS', 'SimSun', 'MS Mincho', 'Batang', 'Gulim',
];

const TEST_STRING = 'mmMwWLliI0O&1';
const TEST_SIZE = '72px';

export function renderFontsFingerprint(): string {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return '';

  const baseMetrics: { [font: string]: { width: number; height: number } } = {};
  for (const font of BASE_FONTS) {
    context.font = `${TEST_SIZE} ${font}`;
    const metrics = context.measureText(TEST_STRING);
    baseMetrics[font] = {
      width: metrics.width,
      height: (metrics.actualBoundingBoxAscent ?? 0) + (metrics.actualBoundingBoxDescent ?? 0),
    };
  }

  return TEST_FONTS.filter(font => isFontDetected(context, font, baseMetrics)).join(',');
}

function isFontDetected(
  context: CanvasRenderingContext2D,
  font: string,
  baseMetrics: { [font: string]: { width: number; height: number } },
): boolean {
  for (const baseFont of BASE_FONTS) {
    context.font = `${TEST_SIZE} "${font}", ${baseFont}`;
    const metrics = context.measureText(TEST_STRING);
    const width = metrics.width;
    const height = (metrics.actualBoundingBoxAscent ?? 0) + (metrics.actualBoundingBoxDescent ?? 0);
    if (width !== baseMetrics[baseFont].width || height !== baseMetrics[baseFont].height) {
      return true;
    }
  }
  return false;
}
